// extracted by mini-css-extract-plugin
export default {"label":"label--Brgl2HHzQh","date":"date--CnDNWSp0Xi"};